// extracted by mini-css-extract-plugin
export default {"sectionTitle":"app_sectionTitle__lJS6H","servicesBoxes":"app_servicesBoxes__csIOC"};